import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { formatCurrency, formatDate } from '../utils/helpers'

export default function PublicProposalPage() {
  const { token } = useParams()
  const [proposal, setProposal] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [notes, setNotes] = useState('')
  const [responded, setResponded] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    fetch(`/api/public/proposal/${token}`)
      .then(r => { if (!r.ok) throw new Error('Not found'); return r.json() })
      .then(setProposal)
      .catch(() => setError('This proposal link is invalid or has expired.'))
      .finally(() => setLoading(false))
  }, [token])

  const respond = async (action) => {
    setSubmitting(true)
    try {
      const r = await fetch(`/api/public/proposal/${token}/respond`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action, client_notes: notes })
      })
      if (!r.ok) throw new Error('Failed')
      setResponded(action)
    } catch { alert('Error submitting response') } finally { setSubmitting(false) }
  }

  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', padding: '4rem' }}><div className="spinner-border text-primary" /></div>
  if (error) return <div style={{ maxWidth: 500, margin: '4rem auto', textAlign: 'center' }}><h2>Proposal Not Found</h2><p className="text-secondary">{error}</p></div>

  const p = proposal
  const alreadyResponded = p.accepted_at || p.declined_at

  return (
    <div style={{ maxWidth: 800, margin: '2rem auto', padding: '0 1rem' }}>
      <div className="card">
        <div className="card-header" style={{ background: '#206bc4', color: '#fff' }}>
          <div>
            <h2 className="card-title mb-0" style={{ color: '#fff' }}>{p.hotel_name}</h2>
            <div style={{ fontSize: '0.85rem', opacity: 0.8 }}>{p.hotel_city}, {p.hotel_state}</div>
          </div>
        </div>
        <div className="card-body">
          <h3 className="mb-3">{p.title}</h3>
          <div className="row mb-4" style={{ fontSize: '0.9rem' }}>
            <div className="col-sm-6"><strong>Prepared for:</strong> {p.contact_name || p.company}</div>
            <div className="col-sm-6"><strong>Company:</strong> {p.company || '---'}</div>
            <div className="col-sm-6"><strong>Date:</strong> {formatDate(p.sent_date)}</div>
            <div className="col-sm-6"><strong>Expires:</strong> {formatDate(p.expires)}</div>
          </div>
          {p.content && <div className="mb-4" style={{ whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>{p.content}</div>}
          <div className="card mb-4" style={{ background: 'var(--tblr-bg-surface-secondary)' }}>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-4"><div className="text-secondary">Subtotal</div><div className="h3 mb-0">{formatCurrency(p.subtotal)}</div></div>
                <div className="col-sm-4"><div className="text-secondary">Tax ({p.tax_rate}%)</div><div className="h3 mb-0">{formatCurrency(p.tax_amount)}</div></div>
                <div className="col-sm-4"><div className="text-secondary">Total</div><div className="h3 mb-0 text-primary">{formatCurrency(p.total)}</div></div>
              </div>
            </div>
          </div>
          {p.notes && <div className="mb-4"><strong>Notes:</strong><p className="text-secondary">{p.notes}</p></div>}

          {responded ? (
            <div className={`alert ${responded === 'accept' ? 'alert-success' : 'alert-warning'}`}>
              {responded === 'accept' ? 'Thank you! Your acceptance has been recorded. The hotel team will follow up shortly.' : 'This proposal has been declined. Thank you for your consideration.'}
            </div>
          ) : alreadyResponded ? (
            <div className="alert alert-info">This proposal has already been {p.accepted_at ? 'accepted' : 'declined'}.</div>
          ) : (
            <div>
              <div className="mb-3"><label className="form-label">Notes or questions (optional)</label><textarea className="form-control" rows={3} value={notes} onChange={e => setNotes(e.target.value)} placeholder="Any questions or special requests..." /></div>
              <div className="d-flex gap-2">
                <button className="btn btn-success btn-lg flex-fill" disabled={submitting} onClick={() => respond('accept')}>Accept Proposal</button>
                <button className="btn btn-outline-secondary btn-lg" disabled={submitting} onClick={() => respond('decline')}>Decline</button>
              </div>
            </div>
          )}
        </div>
        <div className="card-footer text-center text-secondary" style={{ fontSize: '0.8rem' }}>Powered by Leadiox Hotel Sales CRM</div>
      </div>
    </div>
  )
}
